<template>
	<div class="Ticket" v-if="masTicket[0]">
		<div  class="row">
			<div class="col-12 col-xl-8 mx-auto ">
				<div class="row mx-0 align-items-center mb-3">
					
						<base-button type="primary" class="groupfloor mr-3" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
						<div class="tStatus-select mr-3" v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1">
							<el-select
								class="col-md px-0 select-primary"
								v-model="masTicket[0].status" 
								clearable
								placeholder="Назначьте статус заявки"
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="status in masTicketStatus"
									:key="status.value"
									:label="status.label"
									:value="status.value"
								>
								</el-option>
							</el-select>
						</div>
						<base-button type="success" class="groupfloor mr-3" simple @click="saveStatusChange()" v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1">Применить</base-button>
						<base-button type="success" class="groupfloor" simple @click="Reopen()" 
						v-if="(masTicket[0].status == 'closed' || masTicket[0].status == 'solved') && this.$GVO.my_profile.code == masTicket[0].author_id && (!this.$GVO.my_profile.Support == 1 || !this.$GVO.my_profile.adm == 1)">
						Не согласен(а) с решением, открыть заявку</base-button>
							
				</div>
			</div>
		</div>
		<div class="row">

			<div class="col-12 col-xl-8 mx-auto posts">

				<card>
					<div class="ticket-header">
						<div class="row mx-0 mb-2">
							<template v-for="status in masTicketStatus" >
								<span v-if="masTicket[0].status == status.value" :key="status.value"  class="badge"
								:class="[{'badge-warning':masTicket[0].status == 'new'},{'badge-info':masTicket[0].status == 'pending'},{'badge-primary':masTicket[0].status == 'open'},
								{'badge-success':masTicket[0].status == 'solved'},{'badge-default':masTicket[0].status == 'closed'},]">{{status.label}}</span>	
							</template>
							
							<template v-for="priority in masTicketPriority" >
								<span  class="mx-3 badge badge-danger" 
								:key="priority.value"
								v-if="masTicket[0].priority == priority.value">{{priority.label}}</span>	
							</template>
							<!--:class="[{'el-tag--danger':masTicket[0].priority == 'important'},{'el-tag--success':masTicket[0].priority == 'normal'},{'el-tag--warning':masTicket[0].priority == 'notImportant'},
									{'el-tag--default':masTicket[0].priority == 'notSoImportant'}]" -->
							
							<h4 class="ticket-title mb-0" v-if="masTicket[0].name"><span>ID {{ masTicket[0].ticket_id }}</span> {{ masTicket[0].name }}</h4>
						</div>
						
							
						<div class="d-flex">
							<p class="mr-3" v-if="masTicket[0].InsertTime">{{ $GVO.convertDateTimeFromMysql(masTicket[0].InsertTime) }}</p> <p v-if="masTicket[0].author_name">{{ masTicket[0].author_name }}</p>
						</div>
					</div>
					<div class="ticket-body">
						<p v-if="masTicket[0].descr"> {{ masTicket[0].descr }}</p>

						<div class="flat-carousel my-4" v-if="masTicket[0].photos != ''">
							<el-carousel :autoplay="false" arrow="always" type="card" height="400px" v-if="masObjImages != ''">
								<el-carousel-item v-for="obj_img in masObjImages" :key="obj_img">
									<img v-if="obj_img !=''" :src="obj_img" alt="">
								</el-carousel-item>
							</el-carousel>
						</div>

						<!--div v-if="masTicket[0].videoUrl != ''">
							<video controls width="auto" class="TicketVideo my-4">
								<source :src="strVideoUrl" type="video/webm">
								<source :src="strVideoUrl" type="video/mp4">
								Ваш браузер не поддерживает встроенные видео :(
							</video>
						</div-->
					</div>
				</card> 

				<div >
					<ReTicketsLentaNest :ticket_id="masTicket[0].ticket_id" :author_id="masTicket[0].author_id" :status="masTicket[0].status" />
				</div>

			</div>

			<div class="col-md col-xl-4 mt-2" style="display:none;">
				<card>
					<div class="techinfo-header">
						<h4 class="ticket-title mb-0">Информация об авторе заявки</h4>
					</div>
					<div class="techinfo-body">
						<p>тут должны быть разные технические данные</p>
					</div>	
				</card>	
			</div>

		</div>
		
	</div>
</template>

<script>

import { Select, Option, Tag } from 'element-ui';
import ReTicketsLentaNest from 'src/our_components/ReTicketsLentaNest.vue';
import { Carousel, CarouselItem, } from "element-ui";	
import {eventEmitter} from "src/plugins/globalComponents.js";

	export default {
		name: 'Ticket-page',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Tag.name]: Tag,
			ReTicketsLentaNest,
			[Carousel.name]: Carousel,
			[CarouselItem.name]: CarouselItem,
		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: String,
			
		},
		data () {
			return {
				ver: 1,
				masTicket: [],
				masTicketStatus: [],
				masTicketPriority: [],
				masImgs:[],
		
			}
		},
		watch:{

		},
		computed: {
			masObjImages: function(){
				let masImgs = [];
				if(this.masTicket[0].photos != '') {
					// console.log(masTicket[0].photos);
					const arrImages = JSON.parse(this.masTicket[0].photos);
					// console.log(arrImages);
					for (let i = 0; i < arrImages.length; i++){
						masImgs.push(arrImages[i]);	
					}
				}
				return masImgs;
			},
			strVideoUrl: function(){
				let strVideo = '';
				if(this.masTicket[0].videoUrl != '') {
					// console.log(masTicket[0].photos);
					strVideo = JSON.parse(this.masTicket[0].videoUrl);
					// console.log(arrImages);
					// for (let i = 0; i < arrImages.length; i++){
					// 	masImgs.push(arrImages[i]);	
					// }
				}
				return strVideo;
			},

		},
		methods: {
			backByHistory(){
				this.$router.back();
			},
			getApiData(){
				
				this.$GVO.ApiCall('TicketSystem.GET',{flt:{ticket_id:this.$route.params.ticket_id}} ) 
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masTicket = objApi.data;
							// console.log(objApi.data)
							// let aa = this.$GVO.my_profile.fio;
							// console.log(this.$GVO.my_profile.adm);
							
						}else{
							this.masTicket = [];
						}
					}else{
						this.masTicket = [];
						
					}
				}).catch(errorObjApi => {this.masTicket = []; console.error(errorObjApi);});
			},
			saveStatusChange(){

				// if(this.$GVO.my_profile.adm == 1) {
				// 	console.log(this.$GVO.my_profile);
				// 	// Support
				// }

				this.$GVO.ApiCall('TicketSystem.UPD',{flt:{ticket_id: this.$route.params.ticket_id},uData:{
					status:this.masTicket[0].status, 
					sup_agent_id: this.$GVO.my_profile.code , 
					sup_agent_name: this.$GVO.my_profile.fio,
					topicTag: this.masTicket[0].topicTag,
					// status_changed_by_id: this.$GVO.my_profile.code , 
					// status_changed_by_fio: this.$GVO.my_profile.fio,
				 }}) 
				.then((objApi) => {
						// console.log(objApi);
						if(objApi.success === true){

						}else{
							alert('Не сохранилось. Возможно у вас нет прав на обработку заявки');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
				
			},
			Reopen(){
				this.$GVO.ApiCall('TicketSystem.UPD',{flt:{ticket_id: this.$route.params.ticket_id},uData:{
					status:'open',
					sup_agent_id: this.$GVO.my_profile.code , 
					sup_agent_name: this.$GVO.my_profile.fio,
				}}) 
				.then((objApi) => {
						// console.log(objApi);
						if(objApi.success === true){
							this.getApiData();

						}else{
							alert('Не сохранилось. Возможно у вас нет прав на обработку заявки');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});

			},
			getStatusFromLenta(t_status_changed){
				this.masTicket[0].status = t_status_changed;
			}
			// saveStatusChange(){
			// 	this.$GVO.ApiCall('TicketSystem.INS',{iData:{ticket_id:this.$route.params.ticket_id, status:this.masTicket[0].status, sup_agent_id: this.$GVO.my_profile.code , sup_agent_name: this.$GVO.my_profile.fio }})
			// 	.then((objApi) => {
			// 		console.log(objApi.data);
			// 		if(objApi.success === true){ 
			// 			//console.log(objApi.data);
			// 			eventEmitter.$emit('reload_lenta');
			// 		}else{
			// 				alert('Не сохранилось. Возможно у вас нет прав на обработку заявки');
			// 			}
			// 	}).catch(errorObjApi => { console.log(errorObjApi); });
			// },

			// CheckValidate(){
			// 	console.log("this.errors.items "+this.errors.length);
			// 	if(this.errors.items.length > 0){
					
			// 		this.showSwal('validate-error',this.errors.items);
			// 		return false
			// 	}
			// 	return true;
			// },
			// showSwal(type,data=[]){
			// 	// console.log(data);
			// 	if (type === 'validate-error') {
			// 		let masErFields = [];
			// 		for (let i = 0; i < data.length; i++) {
			// 			masErFields.push(data[i].field);
			// 		}
			// 		// console.log(masErFields);
			// 		swal({
			// 			title: 'Ошибка в контактных данных',
			// 			buttonsStyling: false,
			// 			confirmButtonClass: 'btn btn-danger btn-fill',
			// 			html: `Произошла ошибка проверки данных в полях:<br>
			// 				${masErFields.join(', ')}`
			// 		});
			// 	}
			// },

		},
		created(){
			
		},
		mounted() {
			this.$GVO.LoadCatPromise('cat_ticket_priority')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_ticket_priority.length; i++) {
						const element = this.$GVO.cats.cat_ticket_priority[i];
						if(element.act==1) this.masTicketPriority.push({'value':element.value,'label':element.label, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });

			this.$GVO.LoadCatPromise('cat_ticket_status')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_ticket_status.length; i++) {
						const element = this.$GVO.cats.cat_ticket_status[i];
						if(element.act==1) this.masTicketStatus.push({'value':element.value,'label':element.label, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });

			this.getApiData();
			eventEmitter.$on('t_status_changed', this.getStatusFromLenta);
		},
		beforeDestroy() {
			// Отписываемся от события
			eventEmitter.$off('t_status_changed', this.getStatusFromLenta);
		},
	}
</script>
<style scoped>

.Ticket >>> .tStatus-select {min-width: 200px;}
.ticket-header, .techinfo-header {display: flex; flex-direction: column;}
.ticket-body, .techinfo-body  {border-top: 1px solid #6376a8; margin-top: 15px; padding-top: 20px;}
.TicketVideo {height: 500px;}

@media (max-width: 767px) {
	.posts {
		order: 2;
	}
}

</style>
